/**
 * Vuex.Store getters
 * @author LiQingSong
 */
const getters = {
  siteFiexdHeader: state => state.app.siteFiexdHeader,
  siteTopNavEnable: state => state.app.siteTopNavEnable,
  siteSidebarLogo: state => state.app.siteSidebarLogo,
  sidebarOpened: state => state.app.sidebarOpened,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  msgtotal: state => state.user.msgtotal,
  name: state => state.user.name,
  role: state => state.user.role,
  permission_routes: state => state.permission.routes,
  categories: state => state.user.categories,
  companyId: state => state.user.companyId,
  devices: state => state.user.devices,
  companies: state => state.user.companies,
  user: state => state.user,
  logo: state => state.user.logo,
  teles: state =>
    state.user.devices
      .filter(d => d.category === '虫情测报灯' && d.state > 0)
      .sort((a, b) => a.name.localeCompare(b.name, 'zh-CN')),
  metes: state => state.user.devices.filter(d => d.category === '气象监测站'),
  traps: state => state.user.devices.filter(d => d.category === '性诱诱捕器'),
  cameras: state => state.user.devices.filter(d => d.category === '远程监控'),
  scabs: state => state.user.devices.filter(d => d.category === '赤霉病预警仪'),
  spores: state => {
    const devs = state.user.devices.concat(state.user.okq)
    return devs.filter(d => d.category === '智能孢子仪')
  },
  rodents: state => {
    const devs = state.user.devices.concat(state.user.okq)
    return devs.filter(d => d.category === '鼠害监测')
  },
  homePage: state => state.user.homePage,
  statisticPrev: state => state.app.statisticPrev
}
export default getters
